import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
// import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";
import SupplierConstants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { formatToTwoDigits } from "../../../common/Validations";

//Redux
import { useSelector } from "react-redux"; //useDispatch

import "./homeIntro.scss";

import ItemService from "../../../services/supplier_appCommonService";

const HomeIntro = () => {
  const currentDate = new Date();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  // let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "INV") {
      navigate(SupplierConstants.POCOLLABRATION_INVOICE);
    } else if (page === "SUPPLIER") {
      navigate(SupplierConstants.VENDOR_LIST);
    } else if (page === "PO") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "GRN") {
      navigate(SupplierConstants.POCOLLABRATION_GOODS_RECEIVED_NOTE);
    }
  };

  const [totalPoCount, setTotalPoCount] = useState("");
  const [totalPoCountStatus, setTotalPurchaseStatus] = useState(false);

  const [totalGrnCount, setTotalGrnCount] = useState("");
  const [totalGrnCountStatus, setTotalGrnCountStatus] = useState(false);

  const [productdata, setProductdata] = useState({});

  const [supplierCount, setSupplierCount] = useState("");
  const [supplierCountStatus, setSupplierCountStatus] = useState(false);

  const [invoiceCount, setinvoiceCount] = useState("");
  const [invoiceCountStatus, setinvoiceCountStatus] = useState(false);

  // Po count Count
  const loadPurchaseOrder = async () => {
    setTotalPurchaseStatus(true);
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalPoCount(item.total);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalPurchaseStatus(false);
  };
  // Supplier Count
  const loadSupplierCount = async () => {
    setSupplierCountStatus(true);
    let obj = {};

    await ItemService.supplierCount(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setSupplierCount(item.data[0]);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSupplierCountStatus(false);
  };

  // Po count Count
  const loadGrn = async () => {
    setTotalGrnCountStatus(true);
    let obj = {};

    await ItemService.getGoodsReceivedNote(obj).then((item) => {
      console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalGrnCount(item.total);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalGrnCountStatus(false);
  };

  // Po count Count
  const loadInvoiceCount = async () => {
    setinvoiceCountStatus(true);
    let obj = {
      queryName: "getInvoiceListVendor",
      module: "INVOICE",
      page: 1,
      per_page: 10,
    };

    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setinvoiceCount(item.total);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setinvoiceCountStatus(false);
  };

  useEffect(() => {
    loadSupplierCount();

    loadPurchaseOrder();
    loadInvoiceCount();
    loadGrn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setProductdata(appConfig?.homeIntro);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);
  // const [hideItem, setHideItem] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  // useEffect(() => {
  //   const userRole = userData?.roles?.[0]?.roleId || null;

  //   if (userRole === "CUSTOMER") {
  //     setHideItem(true);
  //   } else {
  //     setHideItem(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userData]);

  const ProductSection = ({ data }) => {
    return (
      <div className="hiProductSection">
        <style>{`
          .hiProductSection {
            width: 100%;
            padding: 12px 16px 32px;
            background: #f8fafc;
            border-radius: 20px;
            border: 1px solid #e2e8f0;
          }

          /* ── Header ── */
          .hiProductHeader {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 24px;
          }
          .hiProductHeaderBadge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background: #eef2ff;
            color: #3f51db;
            font-size: 12px;
            font-weight: 600;
            padding: 4px 10px;
            border-radius: 20px;
            margin-bottom: 10px;
            letter-spacing: 0.4px;
            text-transform: uppercase;
          }
          .hiSectionTitle {
            font-size: 1.85rem;
            font-weight: 700;
            color: #1e293b;
            margin: 0 0 8px;
            text-align: center;
            letter-spacing: -0.4px;
          }
          .hiSectionDivider {
            width: 52px;
            height: 3px;
            background: linear-gradient(90deg, #3f51db, #14B8A6);
            border-radius: 4px;
            margin: 0 auto 10px;
          }
          .hiSectionSubTitle {
            font-size:0.9rem;
            color: #64748b;
            font-weight: 400;
            margin: 0;
            text-align: center;
            max-width: 520px;
          }

          /* ── Grid ── */
          .hiProductGrid {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            grid-auto-rows: 210px;
            gap: 12px;
            width: 100%;
          }
          .hiProductItem:nth-child(6n+1) { grid-column: span 3; }
          .hiProductItem:nth-child(6n+2) { grid-column: span 2; }
          .hiProductItem:nth-child(6n+3) { grid-column: span 1; }
          .hiProductItem:nth-child(6n+4) { grid-column: span 1; }
          .hiProductItem:nth-child(6n+5) { grid-column: span 2; }
          .hiProductItem:nth-child(6n+6) { grid-column: span 3; }

          .hiProductItem {
            position: relative;
            overflow: hidden;
            border-radius: 14px;
            border: 2px solid #e2e8f0;
            cursor: pointer;
            box-shadow: 0 2px 10px rgba(0,0,0,0.06);
            transition: box-shadow 0.3s ease, border-color 0.3s ease, transform 0.3s ease;
          }
          .hiProductItem:hover {
            border-color: #3f51db;
            box-shadow: 0 8px 28px rgba(63,81,219,0.18);
            transform: translateY(-3px);
          }
          .hiProductItem img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 0.4s ease;
          }
          .hiProductItem:hover img {
            transform: scale(1.07);
          }
          .hiProductOverlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 36px 14px 14px;
            background: linear-gradient(to top, rgba(15,23,42,0.82) 0%, transparent 100%);
            transform: translateY(100%);
            transition: transform 0.35s ease;
            border-radius: 0 0 12px 12px;
          }
          .hiProductItem:hover .hiProductOverlay {
            transform: translateY(0);
          }
          .hiProductOverlay p {
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            margin: 0;
            letter-spacing: 0.3px;
            text-shadow: 0 1px 4px rgba(0,0,0,0.5);
          }
        `}</style>

        {/* Header */}
        <div className="hiProductHeader">
         
          <p className="hiSectionTitle">{data?.mainTitle}</p>
          <div className="hiSectionDivider"></div>
          <p className="hiSectionSubTitle">{data?.subTitle}</p>
        </div>

        {/* Asymmetric Grid */}
        <div className="hiProductGrid">
          {data?.products?.map((product, index) => (
            <div key={index} className="hiProductItem">
              <img src={product?.image} alt={product?.alt} />
              <div className="hiProductOverlay">
                <p>{product?.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  //role selection
  // const [userRoleData, serUserRoleData] = useState();
  // useEffect(() => {
  //   if (userData?.roles) {
  //     const allowedRoles = ["SALES-ADMIN", "SALES-OFFICER"];
  //     const isAllowed = userData.roles.some((r) =>
  //       allowedRoles.includes(r.roleId),
  //     );
  //     serUserRoleData(isAllowed);
  //   }
  // }, [userData]);
  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row>
                  <Col xs={12} md={2} lg={2}>
                    <div className="welcome">
                      <p>Welcome to</p>
                      <span className="text-nowrap">Invoice Automation Portal</span>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    md={8}
                    lg={8}
                    className="d-flex justify-content-center"
                  >
                    <div className="d-flex justify-content-start align-times-end">
                      {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )}
                      <p className="fw-bold ms-2 fs-2">
                        {appConfig?.customerName}
                      </p>
                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <div className="date commTopButtonRightLeftPadding">
                      {/* <p>Today Date:</p> */}
                      <InputField
                        className="inputBox"
                        label=""
                        name="Fuels"
                        id="Fuels"
                        placeholder=""
                        // type="date"
                        value={formattedDate}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

            
              <style>{`
                .hiCardNew {
                  background: #fff;
                  border-radius: 16px;
                  padding: 15px;
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  height: 120px;
                  box-shadow: 0px 5px 30px rgba(0,0,0,.08);
                  transition: all .3s ease;
                  position: relative;
                }
                .hiCardNew:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 8px 20px rgba(0,0,0,.12);
                  cursor: pointer;
                }
                .hiCardIcon {
                  width: 65px;
                  height: 65px;
                  border-radius: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 26px;
                  flex-shrink: 0;
                }
                .hiCardIcon.orange { background: #FFF3E8; color: #F97316; }
                .hiCardIcon.green  { background: #E8F9EE; color: #22C55E; }
                .hiCardIcon.teal   { background: #E6FAF8; color: #14B8A6; }
                .hiCardIcon.red    { background: #FEE2E2; color: #EF4444; }
                .hiCardContent { flex: 1; }
                .hiCardTitle {
                  font-size: 14px;
                  color: #7A7A7A;
                  font-weight: 500;
                  margin-bottom: 4px;
                }
                .hiCardCount {
                  font-size: 32px;
                  font-weight: 700;
                  color: #222;
                  margin: 0;
                }
                .hiCardArrow {
                  position: absolute;
                  right: 12px;
                  bottom: 12px;
                  width: 28px;
                  height: 28px;
                  border: none;
                  border-radius: 4px;
                  background-color: #3f51db;
                  color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  font-size: 16px;
                }
                .hiCardArrow:hover { background-color: #3245c5; }
              `}</style>

              {/* Purchase Order */}
              <div className="col-lg-3 commTopButtonRightLeftPadding">
                <div className="hiCardNew">
                  <div className="hiCardIcon orange">
                    <i className="bi bi-file-earmark-text"></i>
                  </div>
                  <div className="hiCardContent">
                    <p className="hiCardTitle">Purchase Order</p>
                    <h3 className="hiCardCount">
                      {!totalPoCountStatus ? formatToTwoDigits(totalPoCount || 0) : ""}
                    </h3>
                  </div>
                  <button className="hiCardArrow" onClick={() => navigateToMainPage("PO")}>
                    <i className="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>

              {/* GRN */}
              <div className="col-lg-3 commTopButtonRightLeftPadding">
                <div className="hiCardNew">
                  <div className="hiCardIcon green">
                    <i className="bi bi-clipboard2-check"></i>
                  </div>
                  <div className="hiCardContent">
                    <p className="hiCardTitle">GRN</p>
                    <h3 className="hiCardCount">
                      {!totalGrnCountStatus ? formatToTwoDigits(totalGrnCount || 0) : ""}
                    </h3>
                  </div>
                  <button className="hiCardArrow" onClick={() => navigateToMainPage("GRN")}>
                    <i className="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>

              {/* Invoice */}
              <div className="col-lg-3 commTopButtonRightLeftPadding">
                <div className="hiCardNew">
                  <div className="hiCardIcon teal">
                    <i className="bi bi-receipt-cutoff"></i>
                  </div>
                  <div className="hiCardContent">
                    <p className="hiCardTitle">Invoice</p>
                    <h3 className="hiCardCount">
                      {!invoiceCountStatus ? formatToTwoDigits(invoiceCount || 0) : ""}
                    </h3>
                  </div>
                  <button className="hiCardArrow" onClick={() => navigateToMainPage("INV")}>
                    <i className="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>

              {/* Exceptions */}
              <div className="col-lg-3 commTopButtonRightLeftPadding">
                <div className="hiCardNew">
                  <div className="hiCardIcon red">
                    <i className="bi bi-exclamation-octagon"></i>
                  </div>
                  <div className="hiCardContent">
                    <p className="hiCardTitle">Exceptions</p>
                    <h3 className="hiCardCount">
                      {!supplierCountStatus ? formatToTwoDigits(supplierCount?.count || 0) : ""}
                    </h3>
                  </div>
                  <button className="hiCardArrow" onClick={() => navigateToMainPage("SUPPLIER")}>
                    <i className="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
              {/* Scrolling Message */}
              {/* <Row className="homeintroposter my-2">
                <Col xs={12} md={12} lg={12}>
                  {appConfig?.scrollingTextInHomePage?.enabled === true && (
                    <>
                      <AlertNotifications
                        message={
                          appConfig?.scrollingTextInHomePage?.displayMessage
                        }
                      />
                    </>
                  )}
                </Col>
              </Row> */}
              {/* Scrolling message end */}

              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
    </main>
  );
};
export default HomeIntro;
